"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _web3Calls = _interopRequireDefault(require("../web3Calls"));

var _jsonrpc = require("../jsonrpc");

var _events = _interopRequireDefault(require("../events"));

var _utils = require("./utils");

var _debug = _interopRequireDefault(require("debug"));

var _bignumber = _interopRequireDefault(require("bignumber.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var debug = (0, _debug.default)('MEWconnectWeb3');
var debugErrors = (0, _debug.default)('MEWconnectError');

var _default = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref, res, next) {
    var payload, store, requestManager, eventHub, tx, localTx, ethCalls;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            payload = _ref.payload, store = _ref.store, requestManager = _ref.requestManager, eventHub = _ref.eventHub;

            if (!(payload.method !== 'eth_signTransaction')) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", next());

          case 3:
            tx = payload.params[0];
            localTx = Object.assign({}, tx);
            delete localTx['gas'];
            delete localTx['nonce'];
            ethCalls = new _web3Calls.default(requestManager);
            _context.prev = 8;

            if (store.state.wallet) {
              _context.next = 14;
              break;
            }

            eventHub.emit(_events.default.WALLET_NOT_CONNECTED);
            debug('NOT ACTIVE WALLET IDENTIFIED');
            res((0, _jsonrpc.toError)(payload.id, 'No active wallet: eth_signTransaction', 4002));
            return _context.abrupt("return");

          case 14:
            if (tx.nonce) {
              _context.next = 20;
              break;
            }

            _context.next = 17;
            return store.state.web3.eth.getTransactionCount(store.state.wallet.getAddressString());

          case 17:
            _context.t0 = _context.sent;
            _context.next = 21;
            break;

          case 20:
            _context.t0 = tx.nonce;

          case 21:
            tx.nonce = _context.t0;

            if (tx.gasLimit && !tx.gas) {
              tx.gas = tx.gasLimit;
            } else if (!tx.gasLimit && tx.gas) {
              tx.gasLimit = tx.gas;
            }

            if (!(!tx.gas || new _bignumber.default(tx.gas).lte(0))) {
              _context.next = 29;
              break;
            }

            _context.next = 26;
            return ethCalls.estimateGas(localTx);

          case 26:
            _context.t1 = _context.sent;
            _context.next = 30;
            break;

          case 29:
            _context.t1 = tx.gas;

          case 30:
            tx.gas = _context.t1;
            tx.chainId = !tx.chainId ? store.state.network.type.chainID : tx.chainId;

            if (!(!tx.gasPrice || new _bignumber.default(tx.gasPrice).lte(0))) {
              _context.next = 38;
              break;
            }

            _context.next = 35;
            return store.state.web3.eth.getGasPrice();

          case 35:
            _context.t2 = _context.sent;
            _context.next = 39;
            break;

          case 38:
            _context.t2 = tx.gasPrice;

          case 39:
            tx.gasPrice = _context.t2;
            (0, _utils.getSanitizedTx)(tx).then(function (_tx) {
              eventHub.emit(_events.default.SHOW_TX_CONFIRM_MODAL, _tx, function (_response) {
                if (_response.reject) {
                  debug('USER DECLINED SIGN TRANSACTION');
                  res((0, _jsonrpc.toError)(payload.id, 'User Rejected Request', 4001));
                  return;
                }

                debug('return signed transaction', payload.method, _response);
                res(null, (0, _jsonrpc.toPayload)(payload.id, _response.rawTransaction));
              });
            }).catch(function (e) {
              eventHub.emit(_events.default.ERROR_NOTIFY, e);
              debugErrors('Error: eth_signTransaction', e);
              res(e);
            });
            _context.next = 48;
            break;

          case 43:
            _context.prev = 43;
            _context.t3 = _context["catch"](8);
            debugErrors(_context.t3);
            debugErrors('Error: eth_signTransaction', _context.t3);
            res(_context.t3);

          case 48:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[8, 43]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.default = _default;